// Position ranks from the offseason player pool (2026-06-30), before any games were played.
// The weekly pool is rebuilt from Sleeper and drops players on injured reserve, so "where was this
// player ranked before the season" comes from this frozen copy instead.

export const PRESEASON_RANKS_DATE = "2026-06-30";

/** Position rank (WR1 = 1) by player id. */
export const PRESEASON_POSITION_RANKS = {
  "sleeper-4984": 1,
  "sleeper-11564": 2,
  "sleeper-11566": 3,
  "sleeper-6770": 4,
  "sleeper-4881": 5,
  "sleeper-11560": 6,
  "sleeper-12508": 7,
  "sleeper-6797": 8,
  "sleeper-6904": 9,
  "sleeper-4046": 10,
  "sleeper-7523": 11,
  "sleeper-11563": 12,
  "sleeper-8183": 13,
  "sleeper-13269": 14,
  "sleeper-3294": 15,
  "sleeper-6804": 16,
  "sleeper-4892": 17,
  "sleeper-3163": 18,
  "sleeper-12522": 19,
  "sleeper-9758": 20,
  "sleeper-12545": 21,
  "sleeper-4943": 22,
  "sleeper-5849": 23,
  "sleeper-9228": 24,
  "sleeper-421": 25,
  "sleeper-5870": 26,
  "sleeper-8161": 27,
  "sleeper-13275": 28,
  "sleeper-6768": 29,
  "sleeper-11559": 30,
  "sleeper-11565": 31,
  "sleeper-3257": 32,
  "sleeper-12524": 33,
  "sleeper-7527": 34,
  "sleeper-9229": 35,
  "sleeper-1373": 36,
  "sleeper-7591": 37,
  "sleeper-13404": 38,
  "sleeper-96": 39,
  "sleeper-12510": 40,
  "sleeper-1166": 41,
  "sleeper-12511": 42,
  "sleeper-12500": 43,
  "sleeper-4017": 44,
  "sleeper-13303": 45,
  "sleeper-2307": 46,
  "sleeper-12470": 47,
  "sleeper-2306": 48,
  "sleeper-11557": 49,
  "sleeper-11256": 50,
  "sleeper-13272": 51,
  "sleeper-7585": 52,
  "sleeper-6111": 53,
  "sleeper-6136": 54,
  "sleeper-19": 55,
  "sleeper-8160": 56,
  "sleeper-4972": 57,
  "sleeper-4464": 58,
  "sleeper-8002": 59,
  "sleeper-11562": 60,
  "sleeper-2152": 61,
  "sleeper-11292": 62,
  "sleeper-7610": 63,
  "sleeper-7083": 64,
  "sleeper-827": 65,
  "sleeper-9999": 66,
  "sleeper-9509": 1,
  "sleeper-9221": 2,
  "sleeper-6813": 3,
  "sleeper-4034": 4,
  "sleeper-8138": 5,
  "sleeper-8151": 6,
  "sleeper-9226": 7,
  "sleeper-12527": 8,
  "sleeper-12507": 9,
  "sleeper-4866": 10,
  "sleeper-13287": 11,
  "sleeper-9224": 12,
  "sleeper-5850": 13,
  "sleeper-11584": 14,
  "sleeper-3198": 15,
  "sleeper-8150": 16,
  "sleeper-8155": 17,
  "sleeper-7543": 18,
  "sleeper-7588": 19,
  "sleeper-12529": 20,
  "sleeper-12489": 21,
  "sleeper-12481": 22,
  "sleeper-12490": 23,
  "sleeper-12512": 24,
  "sleeper-6790": 25,
  "sleeper-5892": 26,
  "sleeper-8228": 27,
  "sleeper-7611": 28,
  "sleeper-12534": 29,
  "sleeper-13286": 30,
  "sleeper-5967": 31,
  "sleeper-7021": 32,
  "sleeper-7594": 33,
  "sleeper-11586": 34,
  "sleeper-6806": 35,
  "sleeper-8154": 36,
  "sleeper-4199": 37,
  "sleeper-7567": 38,
  "sleeper-8132": 39,
  "sleeper-4137": 40,
  "sleeper-12533": 41,
  "sleeper-9753": 42,
  "sleeper-12474": 43,
  "sleeper-11655": 44,
  "sleeper-11583": 45,
  "sleeper-8408": 46,
  "sleeper-13337": 47,
  "sleeper-13345": 48,
  "sleeper-11589": 49,
  "sleeper-4035": 50,
  "sleeper-8136": 51,
  "sleeper-9508": 52,
  "sleeper-12469": 53,
  "sleeper-11576": 54,
  "sleeper-13305": 55,
  "sleeper-11647": 56,
  "sleeper-10219": 57,
  "sleeper-9225": 58,
  "sleeper-9511": 59,
  "sleeper-8205": 60,
  "sleeper-9506": 61,
  "sleeper-13405": 62,
  "sleeper-11435": 63,
  "sleeper-13288": 64,
  "sleeper-11575": 65,
  "sleeper-12476": 66,
  "sleeper-12504": 67,
  "sleeper-11643": 68,
  "sleeper-13347": 69,
  "sleeper-9757": 70,
  "sleeper-12455": 71,
  "sleeper-12457": 72,
  "sleeper-11579": 73,
  "sleeper-11569": 74,
  "sleeper-12471": 75,
  "sleeper-11199": 76,
  "sleeper-12467": 77,
  "sleeper-5995": 78,
  "sleeper-8800": 79,
  "sleeper-11581": 80,
  "sleeper-4147": 81,
  "sleeper-6039": 82,
  "sleeper-7564": 1,
  "sleeper-9488": 2,
  "sleeper-9493": 3,
  "sleeper-7547": 4,
  "sleeper-6786": 5,
  "sleeper-6794": 6,
  "sleeper-8112": 7,
  "sleeper-11632": 8,
  "sleeper-5859": 9,
  "sleeper-7569": 10,
  "sleeper-8137": 11,
  "sleeper-8144": 12,
  "sleeper-10229": 13,
  "sleeper-6801": 14,
  "sleeper-7525": 15,
  "sleeper-12526": 16,
  "sleeper-8146": 17,
  "sleeper-12519": 18,
  "sleeper-11635": 19,
  "sleeper-12514": 20,
  "sleeper-7526": 21,
  "sleeper-2133": 22,
  "sleeper-2216": 23,
  "sleeper-11620": 24,
  "sleeper-9997": 25,
  "sleeper-8148": 26,
  "sleeper-5927": 27,
  "sleeper-4983": 28,
  "sleeper-13279": 29,
  "sleeper-8167": 30,
  "sleeper-13281": 31,
  "sleeper-11631": 32,
  "sleeper-8142": 33,
  "sleeper-9487": 34,
  "sleeper-5045": 35,
  "sleeper-5846": 36,
  "sleeper-10232": 37,
  "sleeper-11628": 38,
  "sleeper-13294": 39,
  "sleeper-5947": 40,
  "sleeper-11638": 41,
  "sleeper-4037": 42,
  "sleeper-6819": 43,
  "sleeper-9756": 44,
  "sleeper-8126": 45,
  "sleeper-9754": 46,
  "sleeper-8121": 47,
  "sleeper-8134": 48,
  "sleeper-12530": 49,
  "sleeper-10222": 50,
  "sleeper-13298": 51,
  "sleeper-11646": 52,
  "sleeper-9500": 53,
  "sleeper-11624": 54,
  "sleeper-7049": 55,
  "sleeper-12501": 56,
  "sleeper-12484": 57,
  "sleeper-13346": 58,
  "sleeper-13276": 59,
  "sleeper-13301": 60,
  "sleeper-6783": 61,
  "sleeper-8676": 62,
  "sleeper-11625": 63,
  "sleeper-9504": 64,
  "sleeper-11618": 65,
  "sleeper-11627": 66,
  "sleeper-12492": 67,
  "sleeper-12540": 68,
  "sleeper-6803": 69,
  "sleeper-12509": 70,
  "sleeper-4981": 71,
  "sleeper-13293": 72,
  "sleeper-12535": 73,
  "sleeper-13320": 74,
  "sleeper-12499": 75,
  "sleeper-9502": 76,
  "sleeper-10213": 77,
  "sleeper-12536": 78,
  "sleeper-9494": 79,
  "sleeper-7090": 80,
  "sleeper-13274": 81,
  "sleeper-12547": 82,
  "sleeper-13317": 83,
  "sleeper-8180": 84,
  "sleeper-11783": 85,
  "sleeper-12497": 86,
  "sleeper-13268": 87,
  "sleeper-13353": 88,
  "sleeper-13311": 89,
  "sleeper-7571": 90,
  "sleeper-4039": 91,
  "sleeper-11637": 92,
  "sleeper-12483": 93,
  "sleeper-11834": 94,
  "sleeper-13285": 95,
  "sleeper-4950": 96,
  "sleeper-13417": 97,
  "sleeper-11610": 98,
  "sleeper-6149": 99,
  "sleeper-6271": 100,
  "sleeper-8130": 1,
  "sleeper-11604": 2,
  "sleeper-12517": 3,
  "sleeper-12518": 4,
  "sleeper-12506": 5,
  "sleeper-9484": 6,
  "sleeper-7553": 7,
  "sleeper-10859": 8,
  "sleeper-10236": 9,
  "sleeper-4217": 10,
  "sleeper-12493": 11,
  "sleeper-3214": 12,
  "sleeper-5022": 13,
  "sleeper-5012": 14,
  "sleeper-8110": 15,
  "sleeper-5001": 16,
  "sleeper-7002": 17,
  "sleeper-9480": 18,
  "sleeper-1466": 19,
  "sleeper-13330": 20,
  "sleeper-8131": 21,
  "sleeper-11603": 22,
  "sleeper-5844": 23,
  "sleeper-4033": 24,
  "sleeper-8210": 25,
  "sleeper-6865": 26,
  "sleeper-12498": 27,
  "sleeper-13349": 28,
  "sleeper-12487": 29,
  "sleeper-11597": 30,
  "sleeper-8111": 31,
  "sleeper-12502": 32,
  "sleeper-8698": 33,
  "sleeper-13401": 34,
  "sleeper-13278": 35,
  "sleeper-4066": 36,
  "sleeper-11600": 37,
  "sleeper-4993": 38,
  "sleeper-7600": 39,
  "sleeper-ARI": 1,
  "sleeper-ATL": 2,
  "sleeper-BAL": 3,
  "sleeper-BUF": 4,
  "sleeper-CAR": 5,
  "sleeper-CHI": 6,
  "sleeper-CIN": 7,
  "sleeper-CLE": 8,
  "sleeper-DAL": 9,
  "sleeper-DEN": 10,
  "sleeper-DET": 11,
  "sleeper-GB": 12,
  "sleeper-HOU": 13,
  "sleeper-IND": 14,
  "sleeper-JAX": 15,
  "sleeper-KC": 16,
  "sleeper-LV": 17,
  "sleeper-LAC": 18,
  "sleeper-LAR": 19,
  "sleeper-MIA": 20,
  "sleeper-MIN": 21,
  "sleeper-NE": 22,
  "sleeper-NO": 23,
  "sleeper-NYG": 24,
  "sleeper-NYJ": 25,
  "sleeper-PHI": 26,
  "sleeper-PIT": 27,
  "sleeper-SF": 28,
  "sleeper-SEA": 29,
  "sleeper-TB": 30,
  "sleeper-TEN": 31,
  "sleeper-WAS": 32,
  "sleeper-11261": 1,
  "sleeper-12713": 2,
  "sleeper-13066": 3,
  "sleeper-11058": 4,
  "sleeper-11533": 5,
  "sleeper-2020": 6,
  "sleeper-11786": 7,
  "sleeper-8259": 8,
  "sleeper-10955": 9,
  "sleeper-11653": 10,
  "sleeper-6650": 11,
  "sleeper-1945": 12,
  "sleeper-5189": 13,
  "sleeper-7839": 14,
  "sleeper-4227": 15,
  "sleeper-12015": 16,
  "sleeper-11539": 17,
  "sleeper-4195": 18,
  "sleeper-10937": 19,
  "sleeper-2747": 20,
  "sleeper-5119": 21,
  "sleeper-6528": 22,
  "sleeper-3451": 23,
  "sleeper-6083": 24,
  "sleeper-650": 25,
  "sleeper-12961": 26,
  "sleeper-7042": 27,
  "sleeper-12711": 28,
  "sleeper-3678": 29,
  "sleeper-11792": 30,
  "sleeper-4233": 31,
  "sleeper-8932": 32,
};
